import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createRef } from 'react';
var css = {
  "caret": "rui-caOyG",
  "list": "rui-SiiOb",
  "leftContainer": "rui-kji7F",
  "wrapperBreadcrumb": "rui-2Pidb",
  "normalContainer": "rui-i9YpN",
  "borderGradient": "rui-You"
};
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
var isNormalBreadcrumb = function isNormalBreadcrumb(place) {
  return place === 'normal';
};
var PADDING = 20;
var Breadcrumbs = /*#__PURE__*/function (_React$Component) {
  function Breadcrumbs(props) {
    var _this;
    _classCallCheck(this, Breadcrumbs);
    _this = _callSuper(this, Breadcrumbs, [props]);
    _this.state = {
      showGradient: false
    };
    _this.onResize = function () {
      if (_this.totalWidth > window.innerWidth) {
        _this.scrollToRight();
      }
    };
    _this.breadcrumb = /*#__PURE__*/createRef();
    _this.totalWidth = 1000;
    return _this;
  }
  _inherits(Breadcrumbs, _React$Component);
  return _createClass(Breadcrumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.totalWidth = window.innerWidth;
      window.addEventListener('resize', this.onResize, false);
      this.scrollToRight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollToRight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, false);
      }
    }
  }, {
    key: "hasScrollbar",
    value: function hasScrollbar() {
      var node = this.breadcrumb.current;
      if (node) {
        return node.scrollWidth > node.clientWidth;
      }
      return false;
    }
  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      var hasScrollbar = this.hasScrollbar();
      if (isNormalBreadcrumb(this.props.place) && hasScrollbar) {
        var node = this.breadcrumb.current;
        if (node) {
          node.scrollLeft = PADDING + (node.scrollWidth - node.clientWidth);
        }
      }
      if (this.state.showGradient !== hasScrollbar) {
        this.setState({
          showGradient: hasScrollbar
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        links = _this$props.links,
        place = _this$props.place,
        className = _this$props.className,
        children = _this$props.children,
        separator = _this$props.separator,
        crumbClassname = _this$props.crumbClassname;
      var breadcrumbs = links.filter(function (el) {
        return el && el.text && el.text.length;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(css["".concat(place, "Container")], className)
      }, this.state.showGradient && /*#__PURE__*/React.createElement("div", {
        className: css.borderGradient
      }), /*#__PURE__*/React.createElement("ol", {
        className: css.wrapperBreadcrumb,
        ref: this.breadcrumb
      }, breadcrumbs.map(function (route, idx) {
        return /*#__PURE__*/React.createElement("li", {
          key: idx
        }, /*#__PURE__*/React.createElement(NavLink, {
          to: route.href || '',
          className: function className(_ref) {
            var isActive = _ref.isActive;
            return classNames(crumbClassname, _defineProperty({}, css.active, isActive));
          }
        }, route.text), /*#__PURE__*/React.createElement("span", {
          className: css.caret
        }, separator));
      }), children));
    }
  }]);
}(React.Component);
Breadcrumbs.defaultProps = {
  place: 'normal',
  separator: '/',
  crumbClassname: ''
};
export default Breadcrumbs;